// extracted by mini-css-extract-plugin
export default {"external":"aowZzW","menuContainer":"bowZzW","menuColumn":"cowZzW","header":"dowZzW","divided":"eowZzW","menuBanner":"fowZzW"};